import Domain from "./domain";
export default {
  methods: {
    getStudents: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/student/details?company=" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    geStudentById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/student/details?role&_id=" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postStudent: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "company/student",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putStudent: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company/student",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteStudent: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "company/student/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postStudentImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company/student/avatar",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
